export const countWords = (value: string) => {
  const words = value.trim().match(/\b[\w'-]+\b/g);
  return words ? words.length : 0;
};

export const escapeHtml = (value: string) =>
  value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");

export const slugifyFileName = (value: string, fallback = "document") => {
  const slug = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

  return slug || fallback;
};

export const inferTitle = (markdown: string) => {
  const heading = markdown.match(/^#\s+(.+)$/m);
  return heading?.[1]?.trim() || "Untitled document";
};

export const readingMinutes = (words: number) => Math.max(1, Math.round(words / 220));

/** ATX headings (`#` … `######`) outside fenced code blocks. */
export const extractOutline = (markdown: string) => {
  const items: { line: number; level: number; text: string }[] = [];
  let fence: string | null = null;

  markdown.split("\n").forEach((line, index) => {
    const fenceMatch = /^(```+|~~~+)/.exec(line.trimStart());
    if (fenceMatch) {
      const marker = fenceMatch[1][0] === "`" ? "```" : "~~~";
      if (!fence) fence = marker;
      else if (fence === marker) fence = null;
      return;
    }
    if (fence) return;

    const heading = /^(#{1,6})\s+(.+?)\s*#*\s*$/.exec(line);
    if (!heading) return;
    const text = heading[2].replace(/[*_`~]/g, "").trim();
    if (text) items.push({ line: index, level: heading[1].length, text });
  });

  return items;
};
